import { HTTP_STATUS_CODES } from './HTTP_STATUS_CODES';
import type { HttpStatusCode } from './HttpStatusCode';

/**
 * @group Network
 * @summary Mapping of application error codes to HTTP status codes for special cases
 * 
 * @remarks
 * This constant maps application error codes that don't have a direct 1:1 mapping with HTTP_STATUS_CODES keys
 * to their corresponding HTTP status codes. For direct mappings (e.g., UNAUTHORIZED, FORBIDDEN, NOT_FOUND),
 * use getStatusCodeForErrorCode instead.
 * 
 * @example
 * ```typescript
 * import { ERROR_CODE_TO_STATUS_CODE_MAP, HTTP_STATUS_CODES } from '@shared/constants';
 * 
 * function getStatusCode(errorCode: string): number {
 *   return ERROR_CODE_TO_STATUS_CODE_MAP[errorCode] || HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR;
 * }
 * 
 * const statusCode = getStatusCode('PERMISSION_DENIED'); // 403
 * ```
 */
export const ERROR_CODE_TO_STATUS_CODE_MAP: Record<string, HttpStatusCode> = {
  PERMISSION_DENIED: HTTP_STATUS_CODES.FORBIDDEN,
  VALIDATION_ERROR: HTTP_STATUS_CODES.BAD_REQUEST,
  DATABASE_ERROR: HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR,
  UNKNOWN_ERROR: HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR,
  NETWORK_ERROR: HTTP_STATUS_CODES.SERVICE_UNAVAILABLE,
  TIMEOUT: HTTP_STATUS_CODES.GATEWAY_TIMEOUT,
} as const;

